import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-0">
          <div className="w-full lg:w-[60%] relative z-10">
            <p className="flex items-center gap-2 text-sm font-label text-foreground-500 mb-8">
              <span className="w-2 h-2 rounded-full bg-foreground-950"></span>
              {t('trust.title')}
            </p>
            <blockquote className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-8 max-w-xl">
              <span className="text-6xl md:text-7xl lg:text-8xl text-accent-500/30 leading-none block mb-2 font-heading">&ldquo;</span>
              {t('trust.quote')}
            </blockquote>
            <div className="flex items-center gap-4">
              <div>
                <p className="font-label text-sm font-semibold text-foreground-900">{t('trust.author')}</p>
                <p className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-shield-check-line text-accent-500"></i>
                  {t('trust.role')}
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[40%] lg:absolute lg:right-0 lg:top-0 lg:h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20black%20and%20white%20editorial%20portrait%20of%20a%20confident%20person%20with%20arms%20crossed%2C%20warm%20natural%20daylight%20from%20large%20window%2C%20clean%20minimal%20white%20background%2C%20soft%20shadows%2C%20high-end%20fashion%20editorial%2C%20professional%20and%20approachable%2C%20modern%20business%20portrait%20style&width=800&height=1200&seq=trust-portrait-v2&orientation=portrait"
              alt="Cliente soddisfatto Itaobuy"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}